import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66924a52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "fixed-bottom-right",
  ref: "cMenu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-plus" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "popover-menu"
}
const _hoisted_4 = { class: "menu-element" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Take Photo Or Video", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-camera" })
], -1))
const _hoisted_7 = { class: "menu-element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Upload a File", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-file" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Create Folder", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrapper-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-folder" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      circle: "",
      class: _normalizeClass({ show: _ctx.isShow }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShow = !_ctx.isShow))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("input", {
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:camera', $event.target.value))),
                  type: "file",
                  accept: "video/*, image/*",
                  capture: "environment"
                }, null, 32)
              ]),
              _createElementVNode("label", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("input", {
                  onInput: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('update:folder', $event.target.value); _ctx.testInput($event.target.files)}),
                  type: "file",
                  accept: "video/*, image/*, file/*"
                }, null, 32)
              ]),
              _createVNode(_component_router_link, {
                to: "folder",
                class: "menu-element"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}